import { z } from 'zod';
import { dateValidation } from '../../validation';

export const AppointmentRescheduleSchema = z.object({
  status: z.string().min(1),
  date: dateValidation(),
  rescheduledBy: z.string().optional(),
  rescheduledAt: dateValidation().optional(),
});
